import { Validation } from '@bingads-webui/validation';
import _ from 'underscore';
import { BaseFactory } from './base-factory';
import { IValidationRules } from '../../types';

/**
 * Factory for bigint validation rules
 * @param {Object} options - input for schema property bag and i18n
 */
export class BigIntFactory extends BaseFactory {
  /**
   * Create bigint rules set from schema property
   * @returns {Object} - bigint validation rules set
   */
  create(): IValidationRules {
    const rules: IValidationRules = {
      type: Validation.bigint.type(this.i18n).set({ nullable: this.prop.nullable }),
    };

    if (_.isFinite(this.prop.maximum) || _.isFinite(this.prop.minimum)) {
      const minimum = _.isFinite(this.prop.minimum) ? this.prop.minimum : undefined;
      const maximum = _.isFinite(this.prop.maximum) ? this.prop.maximum : undefined;

      rules.range = Validation.bigint.range(minimum, maximum, this.i18n).set({ nullable: this.prop.nullable });
    }

    return rules;
  }
}
